import {onMounted} from 'vue';
import {useGsap} from './useGsap';

export const useScrollAnimations = () => {
    const {gsap} = useGsap();

    const baseFrom = {
        opacity: 0,
        y: 40,
        scale: 1,
    };
    const baseTo = {
        opacity: 1,
        y: 0,
        ease: 'power3.out',
        duration: 0.8,
    };
    const baseScrollTrigger = {
        start: 'top 90%',
        toggleActions: 'play none none reverse',
    };

    function playOpeningAnimation() {
        console.log('playOpeningAnimation');
        const baseSelector = '.prismic-preview-page';
        // hero
        const heroTitle = gsap.utils.toArray(`${baseSelector} .hero-content .title`);
        const heroDescription = gsap.utils.toArray(`${baseSelector} .hero-content .description`);
        const heroCta = gsap.utils.toArray(`${baseSelector} .ctas`);
        const heroElems = [...heroTitle, ...heroDescription, ...heroCta];

        gsap.fromTo(heroElems, baseFrom, {
            ...baseTo,
            stagger: 0.1,
        });
    }

    onMounted(() => {
        playOpeningAnimation();

        const baseSelector = '.prismic-preview-page';

        // slice elems
        const media = gsap.utils.toArray(`${baseSelector} .slice-features-with-media__media`);
        const tags = gsap.utils.toArray(`${baseSelector} .mui-c-tag`);
        const accordion = gsap.utils.toArray(`${baseSelector} .mkt-c-faq-accordion`);
        const titles = gsap.utils.toArray(`${baseSelector} .slice-title`);
        const links = gsap.utils.toArray(`${baseSelector} .mui-c-link`);
        const listItems = gsap.utils.toArray(`${baseSelector} .slice-description li`);
        const sliceElems = [...media, ...tags, ...titles, ...listItems, ...links, ...accordion];

        // all elems
        const allElems = [...sliceElems];

        allElems.forEach((elem: any) => {
            gsap.fromTo(elem, baseFrom, {
                ...baseTo,
                scrollTrigger: {
                    trigger: elem,
                    ...baseScrollTrigger,
                },
            });
        });
    });

    return {};
};
